// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.47957 2.57965L1 0.661133V12.7144H1.00735C1.22162 18.4582 6.09053 23.0001 12 23.0001C17.9095 23.0001 22.7784 18.4582 22.9926 12.7144H23V0.661133L16.5204 2.57965C15.1397 1.97467 13.6087 1.63879 12 1.63879C10.3913 1.63879 8.86028 1.97467 7.47957 2.57965ZM5.1374 3.97199C4.32311 4.604 3.60238 5.34667 3 6.17708V3.33913L5.1374 3.97199ZM21 3.33913V6.17708C20.3976 5.34667 19.6769 4.604 18.8626 3.97199L21 3.33913ZM9.00003 12H7.00003V9H9.00003V12ZM17 12H15V9H17V12ZM12.8945 14.0528C13.2729 14.8096 13.7514 15.0383 14.0831 15.066C14.4226 15.0942 14.8418 14.9346 15.168 14.4453L15.7227 13.6132L17.3868 14.7226L16.8321 15.5547C16.1583 16.5654 15.0775 17.1558 13.917 17.059C13.2042 16.9996 12.5461 16.6894 12 16.1741C11.454 16.6894 10.7959 16.9996 10.0831 17.059C8.92258 17.1558 7.8418 16.5654 7.16798 15.5547L6.61328 14.7226L8.27738 13.6132L8.83208 14.4453C9.15826 14.9346 9.57748 15.0942 9.91699 15.066C10.2487 15.0383 10.7272 14.8096 11.1056 14.0528L12 12.2639L12.8945 14.0528Z"}}]};

const CatFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cat-filled',
    ref,
    icon: element,
  },
));

CatFilledIcon.displayName = 'CatFilledIcon';

export default CatFilledIcon;
